import { render } from "./EditSalesReturnPage.vue?vue&type=template&id=3b558e28&ts=true"
import script from "./EditSalesReturnPage.vue?vue&type=script&lang=ts"
export * from "./EditSalesReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__